import type { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { type RootState, UserRole } from '../common/types';

export const AgencyGuard: React.FC<PropsWithChildren> = ({ children }) => {
  const isNotAllowed = useSelector(
    (state: RootState) => (state.auth.user?.role ?? UserRole.Creator) === UserRole.Creator,
  );

  if (isNotAllowed) {
    return <Redirect to="/dashboard" />;
  }

  return children;
};
